import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { zAppDevTabViewComponent } from './tabView.component';
import { ZAppDevTabPanel } from './tabPanel.component';
import { TabsModule } from 'primeng/tabs';

const COMPONENTS = [
  zAppDevTabViewComponent,
  ZAppDevTabPanel
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    TabsModule
  ],
  exports: [...COMPONENTS]
})
export class zAppDevTabContainerModule { }
